import { render, staticRenderFns } from "./stickPrimacy.vue?vue&type=template&id=2473cbf0&scoped=true"
import script from "./stickPrimacy.vue?vue&type=script&lang=js"
export * from "./stickPrimacy.vue?vue&type=script&lang=js"
import style0 from "./stickPrimacy.vue?vue&type=style&index=0&id=2473cbf0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2473cbf0",
  null
  
)

export default component.exports